export default "__VITE_ASSET__cf96f3e4__"